import { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'

export interface LvcProfileDesktopScreenWrapper {}

export class LvcProfileDesktopScreenWrapper extends MinzeElement {
  modalId = MODALS.PROFILE_MODAL
  reactive: Reactive = []

  onReady(): void | Promise<void> {}

  html = () => `
    <lvc-profile-desktop-screen-content></lvc-profile-desktop-screen-content>
  `

  css = () => `
    :host {
      
    }
  `
}
